import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto";
import { z } from "zod"

export const LightInvoiceDtoSchema = z.object({
  price: PriceObjectDtoSchema,
  invoiceDate: z.string(),
});

export type LightInvoiceDto = z.infer<typeof LightInvoiceDtoSchema>;